import React from 'react';
import axios from 'axios';

export function useAxios<T>(url: string, onSuccess: (data: T) => void, onError: (error: Error) => void) {
  React.useEffect(() => {
    (async () => {
      try {
        const response = await axios.get<T>(url);
        if (response.status === 200) {
          onSuccess(response.data);
        } else {
          onError(new Error(`${response.status} ${response.statusText}`));
        }
      } catch (e) {
        onError(e as Error);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]);
}

export function useAxiosState<T>(initialValue: T, url: string) {
  const [value, setValue] = React.useState<T>(initialValue);
  const [error, setError] = React.useState<Error>();
  const [status, setStatus] = React.useState<'loading' | 'success' | 'error'>('loading');

  useAxios<T>(
    url,
    (data) => {
      setValue(data);
      setStatus('success');
    },
    (error) => {
      setError(error);
      setStatus('error');
    },
  );

  return {
    value,
    status,
    error,
  };
}
